import React from 'react';

export default () => {
    return (
        <p>Hi this is GenerateRemit.Home</p>
    )
}